import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue'

// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'

// Dashboard pages
import Overview from 'src/pages/Dashboard/Dashboard/Overview.vue'


import Login from 'src/pages/Dashboard/Pages/Login.vue'
import Logout from 'src/pages/Dashboard/Pages/Logout.vue'

const OrderTable = () => import('src/pages/Dashboard/Orders/OrdersTable.vue')
const ReturnTable = () => import('src/pages/Dashboard/Orders/ReturnTable.vue')
const PricesTable = () => import('src/pages/Dashboard/Prices/PricesTable.vue')
//const SalonVAETable = () => import('src/pages/Dashboard/Salons/SalonVAETable.vue')
const BareCodeAction = () => import('src/pages/Dashboard/BareCode/BareCode.vue')

let stockPage = {
    path: '/bc/:bc',
    name: 'BareCode',
    component: BareCodeAction,
    meta: {
        requiresAuth: true,
    },
    params: true
}

let pricesMenu = {
    path: '/prices',
    component: DashboardLayout,
    redirect: '/prices/all',
    meta: {
        requiresAuth: true,
    },
    children: [

        {
            path: 'all',
            name: 'Changement de prix',
            component: PricesTable
        }]

}

let tablesMenu = {
    path: '/orders',
    component: DashboardLayout,
    redirect: '/orders/all',
    meta: {
        requiresAuth: true,
    },
    children: [
        /*{
            path: 'regular',
            name: 'Regular Tables',
            component: RegularTables
        },
        {
            path: 'extended',
            name: 'Extended Tables',
            component: ExtendedTables
        },*/
        {
            path: 'all',
            name: 'Commande en cours',
            component: OrderTable
        },
        {
            path: 'return',
            name: 'Retour commande WEB',
            component: ReturnTable
        },
    ]
}

/*let mapsMenu = {
    path: '/maps',
    component: DashboardLayout,
    redirect: '/maps/google',
    children: [
        {
            path: 'google',
            name: 'Google Maps',
            component: GoogleMaps
        },
        {
            path: 'full-screen',
            name: 'Full Screen Map',
            component: FullScreenMap
        },
        {
            path: 'vector-map',
            name: 'Vector Map',
            component: VectorMaps
        }
    ]
}*/

/*let pagesMenu = {
    path: '/pages',
    component: DashboardLayout,
    redirect: '/pages/user',
    children: [
        {
            path: 'user',
            name: 'User Page',
            component: User
        },
        {
            path: 'timeline',
            name: 'Timeline Page',
            component: TimeLine
        }
    ]
}*/

let loginPage = {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
        requiresVisitor: true,
    }
}

let logoutPage = {
    path: '/logout',
    name: 'Logout',
    component: Logout
}



/*let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}*/

/*let lockPage = {
    path: '/lock',
    name: 'Lock',
    component: Lock
}*/

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: '/orders',
        meta: {
            requiresAuth: true,
        }
    },
    //componentsMenu,
    //formsMenu,
    stockPage,
    tablesMenu,
    pricesMenu,
    //mapsMenu,
    //pagesMenu,
    loginPage,
    logoutPage,
    //lockPage,
    {
        path: '/admin',
        component: DashboardLayout,
        redirect: '/orders',
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: 'overview',
                name: 'Overview',
                component: Overview
            }/*,
            {
                path: 'stats',
                name: 'Stats',
                component: Stats
            },
            {
                path: 'calendar',
                name: 'Calendar',
                component: Calendar
            },
            {
                path: 'charts',
                name: 'Charts',
                component: Charts
            }*/
        ]
    },
    {path: '*', component: NotFound}
]

export default routes
